import { RoleCreatePage } from "@/features/access/pages/role/RoleCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/access/role/create")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["auth_roles.create"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: RoleCreatePage,
});
